import { Box, Button, Dialog, DialogContent, DialogTitle, Grid, Typography } from '@material-ui/core';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { showMessage } from '../../../store/actions/messages.actions';
import { contractWritePermission } from '../../../store/selectors/account.selector';
import store from '../../../store/store';
import { restoreSubscriber, setSubscribersRefresh } from '../../../store/actions/subscribers.actions';
import formatPhone from '../../../utils/formatPhone';

const SubscriberRestoreDialog = ({ handleClose, ...props }) => {
  const dispatch = useDispatch();
  const { action1, actionId1 } = useParams();

  const editPermission = useSelector(contractWritePermission);

  const subscribers = useSelector((state) => state.subscribers.list);
  const [subscriberSelected, setSubscriberSelected] = useState({});
  const [restoreDialog, setRestoreDialog] = useState(false);

  // state effect
  useEffect(() => {
    let unmounted = false;
    const subscriberFromList = actionId1 && (subscribers.find((item) => item.id === actionId1));
    if (action1 === 'restore') {
      setRestoreDialog(true);
    } else {
      setRestoreDialog(false);
    }
    if (action1 === 'restore' && actionId1) {
      setSubscriberSelected({
        ...subscriberFromList,
      });
    }
    return () => {
      unmounted = true;
    };
  }, [action1, actionId1, subscribers]);

  const onRestoreSubscriber = async () => {
    try {
      await store.dispatch(restoreSubscriber(actionId1));
      dispatch(showMessage({ open: true, text: 'Абонент успешно восстановлен', severity: 'success' }));
      handleClose(null, 'success');
      setTimeout(() => dispatch(setSubscribersRefresh()), 500);
    } catch (error) {
      console.log(error);
      dispatch(showMessage({ open: true, text: `Не удалось восстановить. ${error.message}`, severity: 'error' }));
    }
  };

  return (
    <>
      {/* restore dialog */}
      <Dialog {...props} open={restoreDialog} onClose={handleClose} disableRestoreFocus>
        <DialogTitle>
          <Box sx={{ fontSize: '22px' }}>
            Восстановить абонента?
          </Box>
        </DialogTitle>
        <DialogContent sx={{ paddingBottom: '8px' }}>
          <Typography
            color="textSecondary"
            variant="body1"
          >
            <span>Абонент с телефоном </span>
            <strong>{formatPhone(subscriberSelected.phone)}</strong>
            <span> будет восстановлен</span>
          </Typography>
          <Grid
            container
            justifyContent="space-between"
            spacing={2}
            sx={{
              pb: 2,
              pt: 4,
            }}
          >
            <Grid
              item
            >
              <Button
                variant="contained"
                color="secondary"
                fullWidth
                onClick={handleClose}
              >
                Отменить
              </Button>
            </Grid>
            <Grid
              item
            >
              {editPermission && (
                <Button
                  variant="contained"
                  color="secondary"
                  fullWidth
                  onClick={onRestoreSubscriber}
                >
                  Восстановить
                </Button>
              )}
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    </>
  );
};

SubscriberRestoreDialog.propTypes = {
  handleClose: PropTypes.func,
};

SubscriberRestoreDialog.defaultProps = {
  handleClose: null,
};

export default SubscriberRestoreDialog;
